import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<Theme>()((theme) => ({
  addActionButton: {
    border: `1px solid ${theme.palette.primary.main}`,
    '&:disabled': {
      borderColor:
        (theme.palette as any).grey?.[200] ??
        (theme.palette as any).border?.main ??
        theme.palette.divider,
    },
  },
}));
export default useStyles;
